import { render } from "./CardNewsTemplateRight.vue?vue&type=template&id=6bcbe652&scoped=true"
import script from "./CardNewsTemplateRight.vue?vue&type=script&lang=js"
export * from "./CardNewsTemplateRight.vue?vue&type=script&lang=js"

import "./CardNewsTemplateRight.vue?vue&type=style&index=0&id=6bcbe652&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bcbe652"]])

export default __exports__